import { FlowchartLinkAttributeOperator, RuleType } from '@treetop/shared/model';

import { LinkValueInputType, MappedLinkValueType } from './MapperTypes';

export class RuleTypeMapper {
  static mapTypeToSelect(type: RuleType): MappedLinkValueType {
    switch (type) {
      case RuleType.CodeableConcept:
      case RuleType.String:
        return {
          selects: [{ value: '=', translationText: 'Flowchart.Links.Value.Equals', operator: FlowchartLinkAttributeOperator.Equals }],
          inputType: LinkValueInputType.Text,
          payloadAttribute: 'textValue',
        };
      case RuleType.Boolean:
        return {
          selects: [{ value: '=', translationText: 'Flowchart.Links.Value.Equals', operator: FlowchartLinkAttributeOperator.Equals }],
          inputType: LinkValueInputType.Boolean,
          payloadAttribute: 'booleanValue',
        };
      case RuleType.Number:
        return {
          selects: [
            { value: '<', translationText: 'Flowchart.Links.Value.SmallerThan', operator: FlowchartLinkAttributeOperator.SmallerThan },
            {
              value: '<=',
              translationText: 'Flowchart.Links.Value.SmallerThanOrEquals',
              operator: FlowchartLinkAttributeOperator.SmallerThanOrEquals,
            },
            { value: '=', translationText: 'Flowchart.Links.Value.Equals', operator: FlowchartLinkAttributeOperator.Equals },
            {
              value: '>=',
              translationText: 'Flowchart.Links.Value.BiggerThanOrEquals',
              operator: FlowchartLinkAttributeOperator.BiggerThanOrEquals,
            },
            { value: '>', translationText: 'Flowchart.Links.Value.BiggerThan', operator: FlowchartLinkAttributeOperator.BiggerThan },
            { value: 'Between', translationText: 'Flowchart.Links.Value.Range', operator: FlowchartLinkAttributeOperator.Between },
          ],
          inputType: LinkValueInputType.Number,
          payloadAttribute: 'numericalValue',
        };
      case RuleType.DateTime:
        return {
          selects: [{ value: '=', translationText: 'Flowchart.Links.Value.Equals', operator: FlowchartLinkAttributeOperator.Equals }],
          inputType: LinkValueInputType.Text,
          payloadAttribute: 'textValue',
        };
      case RuleType.StringArray:
      case RuleType.NumberArray:
      case RuleType.CodeableConceptValueArray:
        return {
          selects: [
            { value: 'Includes', translationText: 'Flowchart.Links.Value.Includes', operator: FlowchartLinkAttributeOperator.Includes },
          ],
          inputType: LinkValueInputType.Table,
          payloadAttribute: 'codeableConceptValueArray',
        };
      case RuleType.Ratio:
        return {
          selects: [
            { value: '<', translationText: 'Flowchart.Links.Value.SmallerThan', operator: FlowchartLinkAttributeOperator.SmallerThan },
            {
              value: '<=',
              translationText: 'Flowchart.Links.Value.SmallerThanOrEquals',
              operator: FlowchartLinkAttributeOperator.SmallerThanOrEquals,
            },
            { value: '=', translationText: 'Flowchart.Links.Value.Equals', operator: FlowchartLinkAttributeOperator.Equals },
            {
              value: '>=',
              translationText: 'Flowchart.Links.Value.BiggerThanOrEquals',
              operator: FlowchartLinkAttributeOperator.BiggerThanOrEquals,
            },
            { value: '>', translationText: 'Flowchart.Links.Value.BiggerThan', operator: FlowchartLinkAttributeOperator.BiggerThan },
            { value: 'Between', translationText: 'Flowchart.Links.Value.Range', operator: FlowchartLinkAttributeOperator.Between },
          ],
          inputType: LinkValueInputType.Number,
          payloadAttribute: 'numericalValue',
        };
      case RuleType.NumberRange:
      case RuleType.DateTimeRange:
      case RuleType.TimeSpan:
        return {
          selects: [{ value: 'Between', translationText: 'Flowchart.Links.Value.Range', operator: FlowchartLinkAttributeOperator.Between }],
          inputType: LinkValueInputType.Text,
          payloadAttribute: 'textValue',
        };
      default:
        return {
          selects: [{ value: '=', translationText: 'Flowchart.Links.Value.Equals', operator: FlowchartLinkAttributeOperator.Equals }],
          inputType: LinkValueInputType.Text,
          payloadAttribute: 'textValue',
        };
    }
  }
}
